/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type GetContactBoxCompanyInfoQueryVariables = Exact<{
  id: string;
}>;


export type GetContactBoxCompanyInfoQuery = { company_by_pk: { id: string, business_profile: Types.Business_Profile_Enum, contactEmail: string, contactPhoneNumber: string, tradeName: string, legalName: string, description: string | null, brand: Types.Brand_Enum | null, is_wholesaler: boolean, addresses: Array<{ administrativeAreaLevel2: string | null, formattedAddress: string, latitude: number, longitude: number, locality: string | null, postalTown: string | null, postalCode: string | null, countryCode: string }>, photos: Array<{ photo: { path: string, domain: string | null } }>, delivery_zones: Array<{ minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, social_tags: Array<{ type: Types.Social_Tag_Type_Enum, priority: number, level: number, values: { [key: string]: any } | null }> } | null };


export const GetContactBoxCompanyInfoDocument = /*#__PURE__*/ gql`
    query GetContactBoxCompanyInfo($id: uuid!) {
  company_by_pk(id: $id) {
    id
    business_profile
    contactEmail
    contactPhoneNumber
    tradeName
    legalName
    description
    brand
    is_wholesaler
    addresses {
      administrativeAreaLevel2
      formattedAddress
      latitude
      longitude
      locality
      postalTown
      postalCode
      countryCode
    }
    photos {
      photo {
        path
        domain
      }
    }
    delivery_zones {
      minimum_order_value
      minimum_order_value_type
      negotiable_minimum_order_value
      delivery_time
      administrative_areas {
        area
      }
    }
    social_tags(where: {base_unit_sku: {_is_null: true}}) {
      type
      priority
      level
      values
    }
  }
}
    `;

/**
 * __useGetContactBoxCompanyInfoQuery__
 *
 * To run a query within a React component, call `useGetContactBoxCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactBoxCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactBoxCompanyInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactBoxCompanyInfoQuery(baseOptions: Apollo.QueryHookOptions<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables> & ({ variables: GetContactBoxCompanyInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>(GetContactBoxCompanyInfoDocument, options);
      }
export function useGetContactBoxCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>(GetContactBoxCompanyInfoDocument, options);
        }
// @ts-ignore
export function useGetContactBoxCompanyInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>;
export function useGetContactBoxCompanyInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetContactBoxCompanyInfoQuery | undefined, GetContactBoxCompanyInfoQueryVariables>;
export function useGetContactBoxCompanyInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>(GetContactBoxCompanyInfoDocument, options);
        }
export type GetContactBoxCompanyInfoQueryHookResult = ReturnType<typeof useGetContactBoxCompanyInfoQuery>;
export type GetContactBoxCompanyInfoLazyQueryHookResult = ReturnType<typeof useGetContactBoxCompanyInfoLazyQuery>;
export type GetContactBoxCompanyInfoSuspenseQueryHookResult = ReturnType<typeof useGetContactBoxCompanyInfoSuspenseQuery>;
export type GetContactBoxCompanyInfoQueryResult = Apollo.QueryResult<GetContactBoxCompanyInfoQuery, GetContactBoxCompanyInfoQueryVariables>;